import { observable } from 'mobx';

class UiStore {
  @observable grid = {};
  @observable isMobile = false;
  @observable sidebarActive = true;
  @observable gridSize = 0;

  @observable _alert = null;

  set alert(value) {
    this._alert = value;
    setTimeout(() => (this._alert = null), value.timeout);
  }

  get alert() {
    return this._alert;
  }
}

export default new UiStore();
